import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=6208dd4a&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208dd4a",
  null
  
)

export default component.exports